import { Component, HostListener } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SafeHtmlUtils } from '../../../utils/safe-html.util';
import { DisplayContentData, GEDViewerComponent } from '../gedviewer/gedviewer.component';

const MAX_WIDTH = 50; // Représente la largeur que l'on veut donner au visualisateur de PDF dans l'iframe
const MAX_HEIGHT = 70;  // Représente la hauteur que l'on veut donner au visualisateur de PDF dans l'iframe

const cdnImports = '<head><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.7/quill.snow.css"/></head>';

interface IframeDimensions {
  height: number;
  width: number;
}

@Component({
  selector: 'app-froala-content-viewer',
  templateUrl: './froala-content-viewer.component.html',
  styleUrls: ['./froala-content-viewer.component.scss']
})
export class FroalaContentViewerComponent extends GEDViewerComponent  {

  private _iframeDimensions: IframeDimensions = {
    height: 0,
    width: 0
  };

  public get iframeDimensions(): IframeDimensions {
    return this._iframeDimensions;
  }

  public set iframeDimensions(dimensions: IframeDimensions) {
    this._iframeDimensions = dimensions;
  }

  @HostListener('window:resize', ['$event'])
  public onResize(): void {
    this.calcIframeDimensions();
  }

  constructor(protected domSanitizer: DomSanitizer) {
    super(domSanitizer);
    this.calcIframeDimensions();
  }

  public async setData(data: DisplayContentData): Promise<void> {
    setTimeout(() => {
      this._data = data;
      // Si data.data contient déjà un document HTML complet (avec <html>), on l'utilise tel quel
      // c'est le cas des textes de la consultation
      if (typeof data.data === 'string' && data.data.includes('<html>')) {
        this._data.data = this.domSanitizer.bypassSecurityTrustHtml(data.data) as string;
      } else {
        // Sinon, on enveloppe le contenu dans une structure HTML basique
        // On n'ajoute PAS de customPrintStyle ici pour ne pas casser l'impression de l'agenda, 
        // antécédents, vaccins, etc. qui utilisent aussi ce viewer
        const cleanContent = SafeHtmlUtils.sanitizeHtmlString(data.data as string);
        const wrappedHtml = '<html>' + cdnImports + '<body>' + cleanContent + '</body></html>';
        this._data.data = this.domSanitizer.bypassSecurityTrustHtml(wrappedHtml) as string;
      }
    }, 0);
  }

  public calcIframeDimensions(): void {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

    this.iframeDimensions = {
      height: vh * MAX_HEIGHT / 100,
      width: vw * MAX_WIDTH / 100
    };
  }

  public print(document: DisplayContentData): void {
    const iframe = window.frames['quill-iframe'] as Window;
    iframe.print();
  }

}
